import React, { useEffect } from "react";
import {
  Modal,
  Form,
  DatePicker,
  TimePicker,
  Input,
  Button,
  Row,
  Col,
  message as antdMessage,
} from "antd";
import dayjs from "dayjs";
import { postReq } from "../api";

export default function AttendanceRegularizationDialog({
  open,
  onClose,
  initialData = null,
}) {
  const [form] = Form.useForm();

  // Reset / prefill form when dialog opens
  useEffect(() => {
    if (open) {
      if (initialData) {
        form.setFieldsValue({
          date: initialData.date ? dayjs(initialData.date) : null,
          requestedLogin: initialData.requestedLogin
            ? dayjs(initialData.requestedLogin)
            : null,
          requestedLogout: initialData.requestedLogout
            ? dayjs(initialData.requestedLogout)
            : null,
          reason: initialData.reason || "",
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, initialData]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        date: dayjs(values.date).toISOString(),
        requestedLogin: values.requestedLogin
          ? dayjs(values.requestedLogin).toISOString()
          : null,
        requestedLogout: values.requestedLogout
          ? dayjs(values.requestedLogout).toISOString()
          : null,
        reason: values.reason,
      };

      const data = await postReq("/user/correction", payload);

      if (data.status === 200) {
        antdMessage.success(
          data.message || "Correction submitted successfully",
        );
        form.resetFields();
        onClose();
      } else {
        antdMessage.error(data.message || "Something went wrong");
      }
    } catch (err) {
      // Ant Design form validation throws here — ignore those, handle API errors
      if (err?.errorFields) return;
      antdMessage.error(err?.response?.data?.message || "Submission failed");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title={
        <span style={{ color: "#13487D", fontWeight: 700, fontSize: 16 }}>
          Attendance Regularization
        </span>
      }
      width={520}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          style={{ background: "#3699FF", borderColor: "#3699FF" }}
        >
          Submit
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 12 }}>
        {/* Date */}
        <Form.Item
          name="date"
          label="Date"
          rules={[{ required: true, message: "Date is required" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
            disabledDate={(d) => d && d.isAfter(dayjs(), "day")}
            placeholder="Select date"
          />
        </Form.Item>

        <Row gutter={16}>
          {/* Login Time */}
          <Col span={12}>
            <Form.Item name="requestedLogin" label="Login Time">
              <TimePicker
                style={{ width: "100%" }}
                format="hh:mm A"
                use12Hours
                placeholder="Select login time"
              />
            </Form.Item>
          </Col>

          {/* Logout Time */}
          <Col span={12}>
            <Form.Item name="requestedLogout" label="Logout Time">
              <TimePicker
                style={{ width: "100%" }}
                format="hh:mm A"
                use12Hours
                placeholder="Select logout time"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Reason */}
        <Form.Item
          name="reason"
          label="Reason"
          rules={[{ required: true, message: "Reason is required" }]}
        >
          <Input.TextArea
            rows={3}
            placeholder="Briefly describe the reason for correction..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
